import Loadable from 'UIComponents/decorators/Loadable';
const AsyncCreateCustomView = Loadable({
  loader: () => import( /* webpackChunkName: "create-custom-view" */'find-and-filter-components/custom-views-build/public/CreateCustomViewWizard'),
  // don't render a loading spinner for this because it's a UIModalPanel
  LoadingComponent: () => null
});
export default AsyncCreateCustomView;